import { render } from "./NcrmContractsBoardScopeToggle.vue?vue&type=template&id=fdaaedc2&scoped=true"
import script from "./NcrmContractsBoardScopeToggle.vue?vue&type=script&lang=js"
export * from "./NcrmContractsBoardScopeToggle.vue?vue&type=script&lang=js"

import "./NcrmContractsBoardScopeToggle.vue?vue&type=style&index=0&id=fdaaedc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdaaedc2"]])

export default __exports__